import { render, staticRenderFns } from "./DataAvatar.vue?vue&type=template&id=6f475eb3"
import script from "./DataAvatar.vue?vue&type=script&lang=js"
export * from "./DataAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports